import React from "react";
import "../Main.css";
import { MenuBar } from "../../components/MenuBar";
import "../ContentFrame.css";
import Address from "../../components/Address";

const { kakao } = window;

export const Map = () => {
    kakao.maps.load(function () {
        var mapContainer = document.getElementById("map"), // 이미지 지도를 표시할 div
            mapOption = {
                center: new kakao.maps.LatLng(37.377596, 126.943361), // 이미지 지도의 중심좌표
                level: 5, // 이미지 지도의 확대 레벨
                // marker: marker // 이미지 지도에 표시할 마커
            };

        // 이미지 지도를 생성합니다
        var map = new kakao.maps.Map(mapContainer, mapOption);

        var marker = new kakao.maps.Marker({
            // 지도 중심좌표에 마커를 생성합니다
            position: map.getCenter(),
            content: "알리코",
        });
        // 지도에 마커를 표시합니다
        marker.setMap(map);
    });

    return (
        <div className="main_container">
            <MenuBar selected_page={5} />
            <div className="common_frame_container">
                <div className="common_content_container">
                    <div style={{ width: "100%", height: "50px" }}></div>
                    <span className="page_title">찾아오시는길</span>
                    <div className="text_area" style={{ fontSize: "17px"}}>
                        <span style={{ fontWeight: "bold" }}>Address</span>. 경기도 군포시 엘에스로 182번길 22(산본동) /{" "}
                        <span style={{ fontWeight: "bold" }}>Tel.</span> 031-427-4071<br></br>
                        <span style={{ fontWeight: "bold" }}>Fax.</span> 031-427-4567 /{" "}
                        <span style={{ fontWeight: "bold" }}>Email.</span> alnico@alnico.co.kr
                    </div>
                    <div id="map" style={{ width: "650px", height: "350px", margin: "auto", marginTop: "30px" }}></div>
                    <div style={{ width: "100%", height: "100px" }}></div>
                </div>
            </div>
            <Address />
        </div>
    );
};
